import { supabase } from '../lib/supabase';

// Función para obtener el siguiente número correlativo de facturas
export const getNextInvoiceNumber = async (type: 'A' | 'B' | 'C' | 'X'): Promise<string> => {
  try {
    // Obtener el último número de factura del tipo especificado
    const { data, error } = await supabase
      .from('invoices')
      .select('number')
      .eq('type', type)
      .order('number', { ascending: false })
      .limit(1);

    if (error) throw error;

    let nextNumber = 1;
    
    if (data && data.length > 0) {
      // Extraer el número del último registro
      const lastNumber = data[0].number;
      const match = lastNumber.match(/-(\d+)$/);
      if (match) {
        nextNumber = parseInt(match[1]) + 1;
      }
    }

    // Formatear el número con ceros a la izquierda
    return `${type}-${nextNumber.toString().padStart(8, '0')}`;
  } catch (error) {
    console.error('Error generating invoice number:', error);
    // Fallback: usar timestamp si hay error
    return `${type}-${Date.now().toString().substring(6)}`;
  }
};

// Función para obtener el siguiente número correlativo de recibos
export const getNextReceiptNumber = async (): Promise<string> => {
  try {
    // Obtener el último número de recibo
    const { data, error } = await supabase
      .from('payments')
      .select('id')
      .order('created_at', { ascending: false })
      .limit(1);

    if (error) throw error;

    let nextNumber = 1;
    
    if (data && data.length > 0) {
      // Contar todos los pagos existentes para obtener el siguiente número
      const { count, error: countError } = await supabase
        .from('payments')
        .select('*', { count: 'exact', head: true });
      
      if (!countError && count !== null) {
        nextNumber = count + 1;
      }
    }

    // Formatear el número con ceros a la izquierda
    return `R-${nextNumber.toString().padStart(8, '0')}`;
  } catch (error) {
    console.error('Error generating receipt number:', error);
    // Fallback: usar timestamp si hay error
    return `R-${Date.now().toString().substring(6)}`;
  }
};

// Función para obtener el siguiente número correlativo de remitos
export const getNextDeliveryNoteNumber = async (): Promise<string> => {
  try {
    const { supabase } = await import('../lib/supabase');

    const { data, error } = await supabase
      .from('delivery_notes')
      .select('number');

    let nextNumber = 1;

    if (!error && data && data.length > 0) {
      const numbers = data
        .map((note: any) => {
          const n = String(note?.number || '');
          const match = n.match(/(\d+)$/);
          return match ? parseInt(match[1], 10) : 0;
        })
        .filter((num: number) => !isNaN(num) && num > 0);

      if (numbers.length > 0) {
        nextNumber = Math.max(...numbers) + 1;
      }
    }

    return `R-${nextNumber.toString().padStart(8, '0')}`;
  } catch (error) {
    console.error('Error generating delivery note number:', error);
    return `R-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
  }
};
